import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.66675 2.31714H15.6667C16.4123 2.31714 17.0164 2.92116 17.0164 3.66675V15.6667C17.0164 16.4123 16.4123 17.0164 15.6667 17.0164H3.66675C2.92117 17.0164 2.31714 16.4123 2.31714 15.6667V3.66675C2.31714 2.92116 2.92116 2.31714 3.66675 2.31714Z",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }